import React, { Component } from "react";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
import HighlightedCars from "../components/HighlitedCars";
import SocialButtons from "../components/SocialButtons";
import useWindowSize from "../components/useWindowSize";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

const Homepage = () => {
    const { width } = useWindowSize();

    return (
        <div>
            <Carousel controls={false} className="container-header pt-2">
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        sizes="
                            (max-width: 710px) 800w,
                            968w
                        "
                        srcSet="
                            /images/homepage_6_gqusn7_c_scale,w_502.webp 800w,
                            /images/homepage_6_gqusn7_c_scale,w_968.webp 968w"
                        src="/images/homepage_6_gqusn7_c_scale,w_502.webp"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100 cartao"
                        src="/images/homepage_4.webp"
                        alt="Third slide"
                        loading="eager"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/homepage_5.webp"
                        alt="Third slide"
                        loading="lazy"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/StandVendaCruz.webp"
                        alt="Third slide"
                        loading="lazy"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/homepage_1.webp"
                        alt="Third slide"
                        loading="lazy"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/homepage_2.webp"
                        alt="Third slide"
                        loading="lazy"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/homepage_3.webp"
                        alt="Third slide"
                        loading="lazy"
                    />
                </Carousel.Item>
            </Carousel>
            <section
                className="pt-4 financiamento"
                style={{ height: width > 768 ? "170px" : "278px" }}
            >
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-md-10 mx-auto">
                            <div className="separator mb-2" />
                            <h1 className="display-5 font-weight-bold">
                                O seu stand de automóveis usados em Pombal
                            </h1>
                            <h2 className="lead">
                                CARROS INCRÍVEIS COM PREÇOS IMPERDÍVEIS
                            </h2>
                            <div className="separator" />
                        </div>
                    </div>
                </div>
            </section>
            <HighlightedCars />
            <section className="p-3">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-md-12 mx-auto">
                            <p className="d-inline-block px-3 lead highlited_phone_number font-weight-bold">
                                NÃO ENCONTRA O QUE PROCURA? CONTACTE-NOS!
                            </p>
                            <h1 className="display-4 numeroContacto">
                                <FontAwesomeIcon
                                    icon={faPhoneAlt}
                                    className="mr-4"
                                />
                                <a
                                    href="tel:917614429"
                                    className="text-secondary"
                                >
                                    <span>917 614 429</span>
                                </a>
                                <FontAwesomeIcon
                                    icon={faPhoneAlt}
                                    className="ml-4"
                                />
                            </h1>
                            <div className="separator" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="my-3">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-md-10 mx-auto">
                            <h1 className="display-5 font-weight-bold">
                                Por que nós?
                            </h1>
                        </div>
                        <div className="col-md-3">
                            <img
                                src="/images/carro.gif"
                                loading="lazy"
                                className="imagens_porque_nos"
                            />
                            <p className="lead">Aceitamos Retomas</p>
                        </div>
                        <div className="col-md-3">
                            <img
                                src="/images/mecanico.gif"
                                loading="lazy"
                                className="imagens_porque_nos"
                            />
                            <p className="lead">Revisão mecânica</p>
                        </div>
                        <div className="col-md-3">
                            <img
                                src="/images/test-drive.gif"
                                loading="lazy"
                                className="imagens_porque_nos"
                            />
                            <p className="lead">Chave na mão sem papeladas</p>
                        </div>
                    </div>
                </div>
            </section>
            <SocialButtons showSeparator={true} />
            <section className="p-3 financiamento">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-md-10 mx-auto">
                            <h1 className="display-5 font-weight-bold">
                                Precisa de financiamento?
                            </h1>
                            <p className="lead">Estamos aqui para ajudá-lo</p>
                            <p className="lead font-weight-bold">
                                Somos Intermediários de crédito
                            </p>
                            <a
                                href="/images/documento_relativo_atividade_credito_2024.pdf"
                                target="_blank"
                            >
                                <p className="lead">
                                    Documento Atividade de Intermediário de
                                    crédito
                                </p>
                            </a>
                            <a href="tel:917614429">
                                <Button variant="secondary" size="lg">
                                    <FontAwesomeIcon
                                        icon={faPhoneAlt}
                                        className="mr-3"
                                    />
                                    <span>Fale connosco</span>
                                    <FontAwesomeIcon
                                        icon={faPhoneAlt}
                                        className="ml-3"
                                    />
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <div className="parallax" />
            <section className="my-3">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-md-6 mx-auto">
                            <h1 className="font-weight-bold">Sobre Nós</h1>
                            <p className="text-justify">
                                Somos um stand de automóveis com elevada
                                qualidade e ofertas imperdíveis. A nossa missão
                                é ajudar os nossos clientes a encontrar o seu
                                carro de sonho aliado a um serviço de qualidade
                                e excelência. Venha-nos visitar e deixe-nos
                                encontar o seu carro de sonho.
                            </p>
                        </div>
                        <div className="col-md-6 mx-auto ">
                            <img
                                className="img-fluid center-block"
                                src="/images/homepage_porque_nos.webp"
                                alt="Illustrate image of two cars"
                                width={width > 768 ? "450" : "290"}
                                height={width > 768 ? "180" : "115"}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Homepage;
